var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { colorblindPalette, distinctPalette } from '@shared/chart/util';
import { ColorPicker } from '@styled/Form';
import { ColorPalette } from '@util/enums';
import React, { useEffect, useState } from 'react';
// @ts-ignore
import { TwitterPicker as ReactColorPicker } from 'react-color';
import { useModalPosition } from '@hooks/useModalPosition';
import { ChartModalCloseBtn, ColorPickerModal } from '../../styled/Modal';
import { IoMdClose } from 'react-icons/io';
import { useAuth } from '../../providers/AuthProvider';
function ColorPickerInput(_a) {
    var changeHandler = _a.changeHandler, _b = _a.currentColor, currentColor = _b === void 0 ? null : _b;
    var _c = __read(useState(null), 2), oldPosition = _c[0], setOldPosition = _c[1];
    var _d = __read(useModalPosition({
        addOffset: function (rect) {
            return { offsetLeft: -(rect.width / 4), offsetTop: rect.height, visibleOffsetTop: -rect.height / 2 };
        },
    }), 4), clickTargetRef = _d[0], modalRef = _d[1], position = _d[2], clearPositionData = _d[3];
    var userSettings = useAuth().settings;
    var colors = userSettings.user_color_palette === ColorPalette.COLORBLIND ? colorblindPalette : distinctPalette;
    useEffect(function () {
        var fn = function (e) {
            var _a;
            var el = e.target;
            if (!((_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.contains(el))) {
                if (oldPosition === null && position !== null) {
                    setOldPosition(position);
                }
                else {
                    setOldPosition(null);
                    clearPositionData();
                }
            }
        };
        window.addEventListener('click', fn);
        return function () {
            window.removeEventListener('click', fn);
        };
    });
    var colorPicked = function (obj) {
        changeHandler(obj.hex);
    };
    var colorPickerModal = (React.createElement(ColorPickerModal, { ref: modalRef, "$top": "60%", "$left": "45%" },
        React.createElement(ReactColorPicker, { width: 300, triangle: "hide", disableAlpha: true, colors: colors, color: currentColor ? currentColor : '', onChangeComplete: colorPicked }),
        React.createElement(ChartModalCloseBtn, { type: "button", onClick: function () {
                setOldPosition(null);
                clearPositionData();
            }, "aria-label": "Close" },
            React.createElement(IoMdClose, null))));
    return (React.createElement(ColorPicker, { ref: clickTargetRef, "$currColor": currentColor }, oldPosition !== null ? colorPickerModal : React.createElement(React.Fragment, null)));
}
export default ColorPickerInput;
